var _path, _rect, _rect2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetVideoTimeline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1837 0H11.6205C5.15151 0 0.838867 4.31264 0.838867 10.7816V23.7195C0.838867 30.1885 5.15151 34.5011 11.6205 34.5011H33.1837C39.6526 34.5011 43.9652 30.1885 43.9652 23.7195V10.7816C43.9652 4.31264 39.6526 0 33.1837 0ZM26.4775 19.4716L21.1514 22.6629C18.9951 23.9567 17.2269 22.9648 17.2269 20.4419V14.0376C17.2269 11.5148 18.9951 10.5229 21.1514 11.8166L26.4775 15.008C28.526 16.2586 28.526 18.2425 26.4775 19.4716Z",
    fill: "#F3526F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    y: 39.3023,
    width: 44.8046,
    height: 3.14419,
    rx: 1.57209,
    fill: "#F15370"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1494,
    y: 39.3023,
    width: 16.507,
    height: 3.14419,
    rx: 1.57209,
    fill: "#D72A29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1491,
    cy: 40.8744,
    r: 3.14419,
    fill: "#D72A29"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6559,
    cy: 40.8744,
    r: 3.14419,
    fill: "#D72A29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetVideoTimeline);
export default __webpack_public_path__ + "static/media/WIDGET_VIDEO_TIMELINE.b52c07b5fec9e99a513cd3b58a4fcf4a.svg";
export { ForwardRef as ReactComponent };